module.exports = __webpack_public_path__ + "img/huace18.84b7062d.jpg";